module.exports = __webpack_public_path__ + "media/images/mitas-logo-a638cc65966a2d1d5e67f348ae7fb6ac.png";